(function () {
  var desktopQuery = window.matchMedia("(min-width: 769px)");

  function closeOtherLevelOneMenus(currentDetails) {
    document.querySelectorAll("ecx-menu-header > details[data-level='1'][open]").forEach(function (details) {
      if (details === currentDetails) return;

      var summary = details.querySelector("summary");
      details.classList.add("hover-no-animation");
      details.classList.remove("is-open");
      if (summary) summary.setAttribute("aria-expanded", "false");
      details.open = false;
      setTimeout(function () {
        details.classList.remove("hover-no-animation");
      }, 10);
    });
  }

  function openMegaMenu(menuHeader, details) {
    var header = document.querySelector("ecx-header");
    var summary = details.querySelector("summary");

    if (menuHeader && typeof menuHeader.closeOtherLevel1MenusImmediate === "function") {
      menuHeader.closeOtherLevel1MenusImmediate(details);
    } else {
      closeOtherLevelOneMenus(details);
    }

    details.classList.remove("hover-no-animation");
    details.open = true;
    if (summary) summary.setAttribute("aria-expanded", "true");

    details.offsetHeight;
    requestAnimationFrame(function () {
      details.classList.add("is-open");
      if (header) {
        header.classList.add("header-menu--open");
        header.classList.add("header-mega--open");
      }
      if (menuHeader && typeof menuHeader.measureAndEmitMegaMenuHeight === "function") {
        menuHeader.measureAndEmitMegaMenuHeight(details);
      }
      if (menuHeader && typeof menuHeader.observeMegaMenu === "function") {
        menuHeader.observeMegaMenu(details);
      }
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      if (!desktopQuery.matches) return;

      var summary = event.target.closest(
        ".menu--horizontal .main__menu > .menu__item > ecx-menu-header > details[data-level='1'] > summary"
      );

      if (!summary) return;

      var details = summary.closest("details");
      var menuHeader = summary.closest("ecx-menu-header");
      if (!details) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (details.open) {
        details.classList.add("is-open");
        summary.setAttribute("aria-expanded", "true");
        return;
      }

      openMegaMenu(menuHeader, details);
    },
    true
  );
})();
